import { inputStyles } from "../styles/styles";
import { Grid, Link, Button } from "@material-ui/core";
import React, { useMemo } from "react";
import BaseWindow from "./public/BaseWindow";
import { getErrorMessage } from "../utils/enums";
import { connect } from "react-redux";

function CustomerQR(props) {
  const classes = inputStyles();

  const isMobile = /Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent);

  const getMainpageUrl = useMemo(() => {
    try {
      return props.limitAndPaymentInformation?.productList[0]?.shopUrl
        ? props.limitAndPaymentInformation?.productList[0]?.shopUrl?.split(
            ";",
          )[2]
        : "";
    } catch (err) {
      return "";
    }
  }, [props.limitAndPaymentInformation]);
  console.log(getMainpageUrl);
  return (
    <BaseWindow>
      <Grid item xs={12} style={{ textAlign: "center", marginTop: 50 }}>
        <div style={{ width: "100%" }}>
          {!isMobile && (
          <img
            alt="Fibabanka"
            src={
              "https://www.fibabanka.com.tr/images/default-source/qr-kodlari/ticari-musteri-olmak-istiyorum.png"
            }
            width={200}
            height={200}
          /> )}
        </div>
        <div style={{ width: "100%" }}>
          <p className={classes.p}>
            {isMobile
              ? getErrorMessage("MS0031")
                ? getErrorMessage("MS0031")
                : "İşleminize devam etmek için “Müşteri Olmak İstiyorum” butonuna ya da cep telefonunuza SMS ile gönderilen linke tıklayın, FibabankaBiz Mobil üzerinden müşteri olma sürecinizi tamamlayın. Müşteri olma sürecinizi tamamladıktan sonra işleminize yeniden başlamanız gerekmektedir."
              : getErrorMessage("MS0024")
                ? getErrorMessage("MS0024")
                : "Müşteri olmak için QR kodunu okutarak devam edebilirsiniz."}
          </p>
          {isMobile && (
            <Button
              variant="contained"
              color="primary"
              href={
                getErrorMessage("MS0032")
                  ? getErrorMessage("MS0032")
                  : "https://www.fibabanka.com.tr/kurumsalmobil"
              }
              size="small"
              style={{ marginTop: 20, marginBottom: 20, padding: "12px 32px", textTransform: "none" }}
            >
              Müşteri Olmak İstiyorum
            </Button>
          )}
          {getMainpageUrl && getMainpageUrl !== "" && (
            <p className={classes.p}>
              Firma sayfasına dönmek için
              <Link href={getMainpageUrl}> tıklayınız</Link>
            </p>
          )}
        </div>
      </Grid>
    </BaseWindow>
  );
}

const mapStateToProps = (state) => {
  return {
    limitAndPaymentInformation: state.limitAndPaymentInformation,
    processContext: state.processContext,
    alert: state.alert,
  };
};

export default connect(mapStateToProps)(CustomerQR);
